// ===========================================================================
// Clinical Operations Dashboard (Module L) — fake data determinístico.
//
// Backend futuro (según docs/modulos/BillingV2/MODULO_L_CLINICAL_OPS_DASHBOARD.md):
//   GET /api/analytics/clinical-operations            → vistas de agregación `analytics`
//   GET /api/analytics/clinical-operations/{location} → drill-down por location/owner
//
// Lo que hoy no existe en los JSON de muestra (visitas del día, no-show rate)
// se deriva de forma determinística por centro hasta que existan los SPs.
// ===========================================================================

/** Hash determinístico simple para derivar métricas estables por centro. */
export const hashString = (s = "") => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

/**
 * Métricas operativas del día por centro (fake hasta tener scheduling).
 * Futuro: GET /api/analytics/clinical-operations (visitsToday, noShowRate).
 *
 * @param {string} key - location key (e.g. "fort_myers")
 * @param {number} totalPatients - panel del centro
 */
export const getDailyOpsProfile = (key, totalPatients = 0) => {
  const h = hashString(key);
  const visitsToday = Math.round(totalPatients * 0.012) + (h % 7);
  const noShowRate = 8 + (h % 90) / 10; // 8.0% – 16.9%
  return { visitsToday, noShowRate };
};

/**
 * Open care gaps fallback cuando el centro no matchea con
 * centers/performance.json (≈1 gap por paciente según la muestra real).
 */
export const getFallbackCareGaps = (key, totalPatients = 0) =>
  Math.round(totalPatients * 0.95) + (hashString(key) % 120);

/** Locations fallback si locations.json no carga. */
export const FALLBACK_LOCATIONS = [
  { key: "fort_myers", label: "Fort Myers" },
  { key: "fort_pierce", label: "Fort Pierce" },
  { key: "hialeah", label: "Hialeah" },
  { key: "immokalee", label: "Immokalee" },
  { key: "lake_worth", label: "Lake Worth" },
  { key: "lehigh_acres", label: "Lehigh Acres" },
  { key: "lehigh_acres_5705", label: "Lehigh Acres 5705" },
  { key: "naples", label: "Naples" },
  { key: "naples_5262", label: "Naples 5262" },
  { key: "port_st_lucie", label: "Port St. Lucie" },
];
